import { ROUTES } from '../_constants/Routes';

export const isAuthMfaSetupRoute = (path: string) =>
  [ROUTES.AUTH_MFA_SETUP].includes(path);
